import React from 'react'
import { connect } from 'react-redux'
import { navigate } from '@reach/router'
import {
  withStyles,
  AppBar,
  Stepper,
  Step,
  StepButton
} from '@material-ui/core'

import { getWorkflowSteps } from '../../store/workflow/selectors'
import { getAppPDV } from '../../store/app/selectors'
import { computeUrl } from '../atoms/BackButton'

const styles = theme => ({
  stepper: {
    [theme.breakpoints.up('md')]: {
      width: theme.breakpoints.values.md,
      margin: '0 auto'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '10px 12px'
    },
    background: 'inherit'
  }
})

const ProgressBarBase = ({ classes, steps, activeStep, pdvID }) => (
  <AppBar position="static" color="default">
    <Stepper activeStep={activeStep} className={classes.stepper}>
      {steps.map((step, index) => {
        return (
          <Step key={step.label}>
            <StepButton
              onClick={() =>
                index < activeStep && navigate(computeUrl(step.url, pdvID))
              }
              completed={index < activeStep}
            >
              {step.label}
            </StepButton>
          </Step>
        )
      })}
    </Stepper>
  </AppBar>
)

export const ProgressBar = withStyles(styles)(ProgressBarBase)

const mapStateToProps = state => ({
  steps: getWorkflowSteps(state),
  pdvID: getAppPDV(state)
})

export default connect(mapStateToProps)(ProgressBar)
